import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c8a70580&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=c8a70580&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a70580",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8a70580')) {
      api.createRecord('c8a70580', component.options)
    } else {
      api.reload('c8a70580', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c8a70580&scoped=true&", function () {
      api.rerender('c8a70580', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SvgIcon/index.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/SvgIcon/index.vue
// module id = wp/i
// module chunks = 0